import { blupayApi, getApiError } from "../api/client";

/**
 * bridgeService
 *
 * Calls Bridge's hosted onboarding endpoints on the backend:
 *   POST /api/v1/kyc/bridge/start  — creates/resumes Bridge's hosted KYC + ToS flow
 *   GET  /api/v1/kyc/bridge/status — polls Bridge and provisions the wallet once approved
 *
 * BluPay KYC (Sumsub) must already be approved before either of these can
 * succeed — the backend enforces this and returns a 403 otherwise.
 */
export const bridgeService = {
  async start() {
    try {
      const res = await blupayApi.post("/kyc/bridge/start");
      return res.data.data;
    } catch (error) {
      throw getApiError(error);
    }
  },

  async getStatus() {
    try {
      const res = await blupayApi.get("/kyc/bridge/status");
      return res.data.data;
    } catch (error) {
      throw getApiError(error);
    }
  },

  /**
   * Sandbox-only. Simulates Bridge completing hosted KYC/TOS review, then
   * provisions the virtual account like a real approval would. Backend
   * rejects this in production (ENVIRONMENT=production/prod), so this
   * should only ever be wired up behind a dev-only UI affordance.
   */
  async simulateApproval() {
    try {
      const res = await blupayApi.post("/kyc/bridge/simulate-approval");
      return res.data.data;
    } catch (error) {
      throw getApiError(error);
    }
  },
};